import axios from 'axios';
import { envApiUrl } from './envApiUrl';

interface SigninData {
  username: string;
  password: string;
}

export const handleSignIn = async (credentials: SigninData) => {
  try {
    // First, get the CSRF token
    const csrfResponse = await axios.get(envApiUrl + '/auth/csrf-token', {
      withCredentials: true,
    });
    const csrfToken = csrfResponse.data.csrfToken;

    // Then make the signin request with the CSRF token
    const response = await axios.post(envApiUrl + '/auth/signin', credentials, {
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': csrfToken,
      },
      withCredentials: true,
    });
    console.log('Signin response: ', response);
    return response.data;
  } catch (error) {
    console.error('Signin error: ', error);
    throw error;
  }
};
